/* eslint-disable no-param-reassign */
/** Set a `style` property on a `HTMLElement`
 *
 * @returns a `cleanup` function to restore the `style` property to it's original state
 */
export function setStyle<Property extends string & keyof CSSStyleDeclaration>(
	el: HTMLElement,
	css: { [key: string]: CSSStyleDeclaration[Property] },
): () => void {
	const originalCss: { [key: string]: CSSStyleDeclaration[Property] } = {};

	Object.keys(css).forEach((property: string) => {
		// eslint-disable-next-line @typescript-eslint/consistent-type-assertions
		originalCss[property] = el.style[property as Property];
		// eslint-disable-next-line @typescript-eslint/consistent-type-assertions
		el.style[property as Property] = css[property];
	});

	return () => {
		Object.keys(originalCss).forEach((property: string) => {
			// eslint-disable-next-line @typescript-eslint/consistent-type-assertions
			el.style[property as Property] = originalCss[property];
		});
	};
}
